import {useMemo} from 'react';
import {AUTH_INIT_MODELS, resolveHousingName} from '@chekin/core';
import {useChekinSDK} from 'context/ChekinSDK';
import {useReservation} from 'context/reservation';
import {useHousing} from 'hooks/useHousing';

function useArrivalProperty() {
  const {objectId, modelName} = useChekinSDK();
  const {data: reservation, isLoading: isReservationLoading} = useReservation();

  const housingId =
    modelName === AUTH_INIT_MODELS.housing ? objectId : reservation?.housing_id;

  const {housing, housingLocation, isLoading} = useHousing({housingId});

  const isResolving =
    modelName === AUTH_INIT_MODELS.housing ? false : Boolean(isReservationLoading);

  const city = housingLocation?.city;
  const country = housingLocation?.country?.name;
  const address = housingLocation?.address;
  const name = resolveHousingName(housing, reservation);
  const isPoliceRegistered = Boolean(housing?.is_police_registration_enabled);
  const isPropertyLoading = isResolving || (Boolean(housingId) && isLoading);

  return useMemo(
    () => ({
      housingId,
      name,
      address,
      location: [city, country].filter(Boolean).join(' · '),
      city,
      country,
      isPoliceRegistered,
      isLoading: isPropertyLoading,
    }),
    [housingId, name, address, city, country, isPoliceRegistered, isPropertyLoading],
  );
}

export {useArrivalProperty};
